import _ from 'lodash';
import { DRIVERS_RAYON } from '../constants/order';
import { isStringNotNull } from './tools';

export function getAddressFormatted(address) {
  if (typeof address !== 'string') {
    const { streetNumber = '', street = '', city, street2, instruction } = address;
    const formatedAddress = { street: `${streetNumber} ${street}`, city, street2, instruction };
    return _.values(formatedAddress)
      .filter(elt => isStringNotNull(elt))
      .join(', ');
  }
  return address;
}

export function getDistanceFromLatLonInKm(lat1 = 0, lon1 = 0, lat2, lon2) {
  const R = 6371; // Radius of the earth in km
  const dLat = deg2rad(lat2 - lat1); // deg2rad below
  const dLon = deg2rad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c; // Distance in km
  return d;
}

const deg2rad = deg => deg * (Math.PI / 180)

export function getClosedDrivers(drivers, position, distanceKmMax = DRIVERS_RAYON) {
  const { latitude: latShop, longitude: longShop } = position;
  const closedDrivers = [];
  _.forEach(drivers, driver => {
    const { lat, long } = driver;
    if (getDistanceFromLatLonInKm(lat, long, latShop, longShop) < distanceKmMax) {
      closedDrivers.push(driver);
    }
  });
  return closedDrivers;
}
